import { createMachine } from 'xstate';

import shared from 'common/bento/shared';
import { BentoModuleDoneStatus } from 'common/bento/types/BentoModule';
import { AnyMachineEvent } from 'features/Bento/types/Abstract';

import actions, { Action } from './actions';
import guards, { Guard } from './guards';
import model, { Context } from './model';
import services from './services';
import { State } from './state';

const machine = createMachine<Context, AnyMachineEvent>(
  {
    context: model.initialContext,

    id: 'shine-start-verification',

    initial: State.INIT,

    on: {
      '*': {
        actions: shared.actions.unhandled(),
      },
    },

    states: {
      [State.INIT]: {
        always: [
          {
            cond: Guard.ShouldSkipIntro,
            target: State.HOME,
          },
          {
            target: State.INTRO,
          },
        ],
      },

      [State.INTRO]: {
        entry: shared.actions.trackView(),

        on: {
          NEXT: State.HOME,
          PREV: State.ABORT,
        },
      },

      [State.HOME]: {
        entry: shared.actions.trackView(),

        on: {
          NEXT: State.DONE,
          PREV: State.ABORT,
          SELECT_DOCUMENT: [
            {
              actions: Action.AssignSelectedDocumentId,
              cond: Guard.IsSelectedDocumentHandWrittenProofOfIdentity,
              target: State.HANDWRITTEN_IDENTITY_INIT,
            },
            {
              actions: Action.AssignSelectedDocumentId,
              target: State.DOCUMENT_INIT,
            },
          ],
        },
      },

      [State.DOCUMENT_INIT]: {
        always: [
          {
            cond: Guard.IsSelectedDocumentRefused,
            target: State.DOCUMENT_REFUSED,
          },
          {
            target: State.DOCUMENT_UPLOAD,
          },
        ],
      },

      [State.DOCUMENT_REFUSED]: {
        entry: shared.actions.trackView(),

        on: {
          NEXT: State.DOCUMENT_UPLOAD,
          PREV: State.HOME,
        },
      },

      [State.DOCUMENT_UPLOAD]: {
        entry: shared.actions.trackView(),

        on: {
          NEXT: State.HOME,
          PREV: State.HOME,
        },
      },

      [State.HANDWRITTEN_IDENTITY_INIT]: {
        always: [
          {
            cond: Guard.IsSelectedDocumentRefused,
            target: State.HANDWRITTEN_IDENTITY_REFUSED,
          },
          {
            target: State.HANDWRITTEN_IDENTITY_INFO,
          },
        ],
      },

      [State.HANDWRITTEN_IDENTITY_REFUSED]: {
        entry: shared.actions.trackView(),

        on: {
          NEXT: State.HANDWRITTEN_IDENTITY_INFO,
          PREV: State.HOME,
        },
      },

      [State.HANDWRITTEN_IDENTITY_INFO]: {
        entry: shared.actions.trackView(),

        on: {
          NEXT: State.HANDWRITTEN_IDENTITY_UPLOAD,
          PREV: State.HOME,
        },
      },

      [State.HANDWRITTEN_IDENTITY_UPLOAD]: {
        entry: shared.actions.trackView(),

        on: {
          NEXT: State.HOME,
          PREV: State.HANDWRITTEN_IDENTITY_INFO,
        },
      },

      [State.DONE]: {
        data: {
          status: BentoModuleDoneStatus.DONE,
        },
        type: 'final',
      },

      [State.ABORT]: {
        data: {
          status: BentoModuleDoneStatus.ABORT,
        },
        type: 'final',
      },
    },
  },

  {
    actions,
    guards,
    services,
  },
);

export default machine;
